import type { ReactNode } from 'react';

export const symbol_person_4: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M367-487q-47-47-47-113v-140q0-25 17.5-42.5T380-800q15 0 28.5 7t21.5 20q8-13 21.5-20t28.5-7q15 0 28.5 7t21.5 20q8-13 21.5-20t28.5-7q25 0 42.5 17.5T640-740v140q0 66-47 113t-113 47q-66 0-113-47Zm184-42q29-29 29-71v-120H380v120q0 42 29 71t71 29q42 0 71-29ZM160-180v-34q0-38 19-65t49-41q67-30 128.5-45T480-380q62 0 123 15.5t127.92 44.69q31.3 14.13 50.19 40.97Q800-252 800-214v34q0 24.75-17.62 42.37Q764.75-120 740-120H220q-24.75 0-42.37-17.63Q160-155.25 160-180Zm60 0h520v-34q0-16-9.5-30.5T707-266q-64-31-117-42.5T480-320q-57 0-111 11.5T252-266q-14 7-23 21.5t-9 30.5v34Zm260 0Zm0-540Z"
		/>
	</svg>
);
